<div class="adding-cc">
  <div class="adding-cc__gif">
    <layout-loader-gif></layout-loader-gif>
  </div>
  <h1 class="adding-cc__title">Agregando tu tarjeta en Powerpay</h1>
  <p class="adding-cc__description">
    La operación puede tardar unos segundos, por<br />
    favor espera y no actualices esta pantalla.
  </p>
</div>
